import React from "react";
import DispatchLayout from "@/layouts/DispatchLayout";

interface DispatchQueuePanelProps {
  resources: any[];
  selectedDate: Date;
  dateRange: { start: Date; end: Date };
  onDataUpdate: (data: any) => void;
  onResourceAssignment: (eventId: string, resourceIds: string[]) => Promise<any>;
  onUnassignedJobDrop: (
    jobId: string,
    targetResourceId: string,
    targetTime?: Date
  ) => void;
  isUpdating: boolean;
  onModalOpen: () => void;
  onDispatchLayoutToggle: () => void;
  isDispatchLayoutVisible: boolean;
  onAssignedLegClick?: (leg: any) => void;
}

const DispatchQueuePanel: React.FC<DispatchQueuePanelProps> = ({
  resources,
  selectedDate,
  dateRange,
  onDataUpdate,
  onResourceAssignment,
  onUnassignedJobDrop,
  isUpdating,
  onModalOpen,
  onDispatchLayoutToggle,
  isDispatchLayoutVisible,
  onAssignedLegClick,
}) => {
  return (
    <div className="h-full">
      <DispatchLayout
        resources={resources}
        selectedDate={selectedDate}
        subtitle={`${dateRange.start.toLocaleDateString()} - ${dateRange.end.toLocaleDateString()}`}
        onDataUpdate={onDataUpdate}
        onResourceAssignment={onResourceAssignment}
        onUnassignedJobDrop={onUnassignedJobDrop}
        isUpdating={isUpdating}
        onModalOpen={onModalOpen}
        showDispatchLayoutToggle={true}
        onDispatchLayoutToggle={onDispatchLayoutToggle}
        isDispatchLayoutVisible={isDispatchLayoutVisible}
        onAssignedLegClick={onAssignedLegClick}
      />
    </div>
  );
};

export default DispatchQueuePanel;
